import { render, staticRenderFns } from "./MIframe.vue?vue&type=template&id=5ad94d87&scoped=true"
import script from "./MIframe.vue?vue&type=script&lang=ts"
export * from "./MIframe.vue?vue&type=script&lang=ts"
import style0 from "./MIframe.vue?vue&type=style&index=0&id=5ad94d87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad94d87",
  null
  
)

export default component.exports